import React from "react";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes";
import HelmetProvider from "./HelmetProvider";

function App() {
  return (
    <BrowserRouter>
      <HelmetProvider>
        <AppRoutes />
      </HelmetProvider>
    </BrowserRouter>
  );
}

export default App;
